"use strict";Object.defineProperty(exports, "__esModule", {value: true});// Refusals from the backend's org-creation gate (apps/backend/pkg/orgcreation),
// worded for users. Keep these strings identical to the Go error messages.
 const ORG_CREATION_COUNTRY_REFUSAL =
  'New organizations can only be created from the United States, Canada or Puerto Rico.'; exports.ORG_CREATION_COUNTRY_REFUSAL = ORG_CREATION_COUNTRY_REFUSAL
 const ORG_CREATION_PHONE_REFUSAL =
  'New organizations need a verified phone number from the United States, Canada, Puerto Rico or Mexico. Add one to your profile first.'; exports.ORG_CREATION_PHONE_REFUSAL = ORG_CREATION_PHONE_REFUSAL

const ORG_CREATION_REFUSALS = [exports.ORG_CREATION_COUNTRY_REFUSAL, exports.ORG_CREATION_PHONE_REFUSAL]

const getErrorMessage = (err) => {
  if (!err || typeof err !== 'object') return undefined
  const response = (err ).response
  if (response) return response.Error
  return (err ).Error
}

// getOrgCreationRefusal returns the refusal message from a REST error
// ({ response: { Error } }) or a WebSocket CommandError, or null.
 const getOrgCreationRefusal = (err) => {
  const message = getErrorMessage(err)
  return typeof message === 'string' && ORG_CREATION_REFUSALS.includes(message) ? message : null
}; exports.getOrgCreationRefusal = getOrgCreationRefusal
